export default __webpack_public_path__ + "static/media/0000..0007.a0c012d3.png";